import React from 'react';
import {
    Button, Col, Container, Row,
    Spinner,
} from 'reactstrap';
import { isNil } from 'lodash-es';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { getShortUTC } from '@s20/common/util/date';
import CommonContext from '../Common';
import { SmallButton } from '../common/forms/FormElements';
import { PriceDisplay } from '../common/PriceDisplay';

export class MinimumWageRateGrid extends React.Component {
    static contextType = CommonContext;

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            showForm: false,
        };
    }

    componentDidMount() {
        this.populateState();
    }

    populateState() {
        this.setState({
            loading: false,
        });
    }

    render() {
        if (this.state.loading) {
            return (<Spinner />);
        }

        const { minWageRates } = this.props;

        return (
            <Container fluid>
                <Row className="pb-1">
                    <Col className="ml-0 mr-0">
                        <div className="d-flex flex-row align-items-center justify-content-end">
                            <CommonContext.Consumer>
                                {(value) => (
                                    <SmallButton
                                        type="button"
                                        disabled={!!value.formIsOpen}
                                        onClick={this.props.onAddMinWageRate}
                                    >
                                        <i className="fa fa-plus-circle fa-md mr-2" />
                                        Add Min. Wage Rate
                                    </SmallButton>
                                )}
                            </CommonContext.Consumer>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col className="ml-0 mr-0">
                        <table className="table table-sm table-bordered">
                            <thead>
                                <tr>
                                    <th style={{ width: '15%' }}>Min. Wage Rate</th>
                                    <th style={{ width: '20%' }}>Effective Date</th>
                                    <th style={{ width: '20%' }}>Expiration Date</th>
                                    <th
                                        className="text-center"
                                        style={{ width: '5%' }}
                                    >
                                        <FontAwesomeIcon icon={faEdit} />
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {!(minWageRates ?? []).length ? (
                                    <tr>
                                        <td
                                            colSpan="9"
                                            className="text-center"
                                        >
                                            No rates found.
                                        </td>
                                    </tr>
                                ) : this.props.minWageRates.map((rate) => (
                                    <tr key={rate.id}>
                                        <td>
                                            {!isNil(rate.payRate) && <PriceDisplay amount={rate.payRate} />}
                                        </td>
                                        <td>
                                            {!isNil(rate.startDate) && getShortUTC(rate.startDate)}
                                        </td>
                                        <td>
                                            {!isNil(rate.endDate) && getShortUTC(rate.endDate)}
                                        </td>
                                        <td
                                            className="text-center"
                                            style={{ width: '30px' }}
                                        >
                                            <CommonContext.Consumer>
                                                {(value) => (
                                                    <Button
                                                        disabled={!!value.formIsOpen}
                                                        type="button"
                                                        color="outline-primary"
                                                        onClick={() => this.props.onEditMinWageRate(rate)}
                                                        size="sm"
                                                    >
                                                        Edit
                                                    </Button>
                                                )}
                                            </CommonContext.Consumer>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </Col>
                </Row>
            </Container>
        );
    }
}
